import { css } from '@emotion/react';

const fontBaseSize = 16;
export const p2r = (v) => `${v / fontBaseSize}rem`;

export const Secondary = `'EconSans', sans-serif`;

export const SecondaryProps = css`
  font-family: 'EconSans', sans-serif;
`;

export const Primary = `'GTZirkon', sans-serif`;

export const PrimaryProps = css`
  font-family: 'GTZirkon', sans-serif;
`;

export const BasicFontForEconomistComponentsQ = css`
  font-family: 'EconSans', sans-serif;
`;

export const BasicFontForEconomistComponents = `'EconSans', sans-serif`;

export const fontSizes = {
  h1: css`
    font-size: clamp(2.8125rem, 2.1523rem + 2.8169vw, 4.6875rem);
  `,
  h2: css`
    font-size: clamp(1.875rem, 1.6109rem + 1.1268vw, 2.625rem);
  `,
  h3: css`
    font-size: ${p2r(22)};
  `,
  text: css`
    font-size: ${p2r(18)};
  `,
  smallText: css`
    font-size: ${p2r(16)};
  `,
  largeText: css`
    font-size: ${p2r(24)};
  `,
  buttonText: css`
    font-size: ${p2r(20)};
  `,
};

export default {
  PrimaryLight: css`
    font-family: ${Primary};
    font-weight: 300;
  `,
  PrimaryRegular: css`
    font-family: ${Primary};
    font-weight: 400;
  `,
  PrimaryMedium: css`
    font-family: ${Primary};
    font-weight: 500;
  `,
  PrimaryBold: css`
    font-family: ${Primary};
    font-weight: 700;
  `,
  SecondaryLight: css`
    font-family: ${Secondary};
    font-weight: 300;
  `,
  SecondaryRegular: css`
    font-family: ${Secondary};
    font-weight: 400;
  `,
  SecondaryMedium: css`
    font-family: ${Secondary};
    font-weight: 500;
  `,
  SecondaryBold: css`
    font-family: ${Secondary};
    font-weight: 700;
  `,
};
